import axios from 'axios'
import './axios-config'
import querystring from 'query-string'

// console.log(process.env.NODE_ENV)
export default {
    /**
     * 接口得url地址
     */
    BASE_URL_COM: process.env.BASE_URL_COM,
    BASE_URL: process.env.BASE_URL,
    STATIC_URL: process.env.STATIC_URL,
    // test : http://10.150.33.211:9001
    // BASE_URL: process.env.NODE_ENV === 'production' ? 'http://58.56.96.34:19001' : 'http://10.150.33.250:9001',
    // H_BASE_URL: 'http://10.150.33.144',
    // STATIC_URL: process.env.NODE_ENV === 'production' ? 'http://58.56.96.34:19001' : 'http://172.16.100.12:8080/uploadFiles',
    NO_HEADER_URL: ['https://free-api.heweather.net/s6/weather/forecast'],
    /**
     * post 请求方法
     * @param url :string 接口地址
     * @param data :object  数据
     */
    post (url, data) {
        return new Promise((resolve, reject) => {
            axios.post(this.BASE_URL + url, data || {})
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    /**
    * post 请求方法
    * @param url :string 接口地址
    * @param data :object  数据
    */
    postCom (url, data) {
        return new Promise((resolve, reject) => {
            axios.post(url, data || {}, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    /**
     * get 请求方法
     */
    get (url, data) {
        return new Promise((resolve, reject) => {
            axios.get(this.BASE_URL + url, {
                params: data || {}
            })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    /**
     * post 请求方法
     * @param url :string 接口地址
     * @param data :object  数据
     */
    postMock (url, data) {
        return new Promise((resolve, reject) => {
            axios.post(url, data || {})
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    /**
     * 外网的get方法
     */
    extranetGet (url, data) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: data || {}
            })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    /**
     * 目前是这个
     *  query 方式post
     * @param url
     * @param data
     * @return {Promise<any>}
     */
    querystringifyPost (url, data) {
        return new Promise((resolve, reject) => {
            axios.post(this.BASE_URL + url + '?' + querystring.stringify(data))
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    // 请求任意地址
    queryAnyAddrPost (url, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '?' + querystring.stringify(data))
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    // 华哥
    querystringifyPostH (url, data) {
        return new Promise((resolve, reject) => {
            axios.post(this.H_BASE_URL + url + '?' + querystring.stringify(data))
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    /**
     * 上传文件
     */
    uploadData (url, data) {
        return new Promise((resolve, reject) => {
            let formData = new FormData()
            for (let key in data) {
                // val值为数组
                if (data[key] instanceof Array) {
                    data[key].map((item) => {
                        console.log(item)
                        formData.append(key, item)
                    })
                } else {
                    // val直接能用
                    formData.append(key, data[key])
                }
            }
            // formData.append("file", data.file[0])
            axios.post(this.BASE_URL + url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js